import { render, staticRenderFns } from "./NotificationPanelList.vue?vue&type=template&id=7b4f70e5"
import script from "./NotificationPanelList.vue?vue&type=script&lang=js"
export * from "./NotificationPanelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports